import { RootState } from "@/store/types";
import { Module } from "vuex";
import { actions } from "./actions";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { StatisticState } from "./types";

export const state: StatisticState = {
  whatsappStatisticDetail: [],
  whatsappStatisticGroup: [],
  whatsappGroupings: {
    whatsappGroup: [
      'hour',
      'day',
      'week',
      'month',
    ],
    whatsappGroupOptionally: [
      'broker_account_login',
      'originator',
      'message_type',
      'template_id',
      'bulk_id',
  ],
  },
};

export const whatsappStatistic: Module<StatisticState, RootState> = {
  state,
  actions,
  getters,
  mutations,
};